import { Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';

@Component({
  templateUrl: './slidedown.html',
  selector: 'slidedown',
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({opacity: '0', height: '0', overflow: 'hidden'}),
        animate('.2s ease-in', style({opacity: '1', height: '*'}))
      ]),
    ]),
    trigger('fadeOut', [
      transition(':leave', [
        style({opacity: '1', height: '*', overflow: 'hidden'}),
        animate('.2s ease-out', style({opacity: '0', height: '0'}))
      ])
    ])
  ]
})
export class SlidedownComponent {
  @Output() public toggle: EventEmitter<boolean> = new EventEmitter();

  @Input() public set state(state: boolean) {
    if (this._state !== state) {
      this._state = state;
      this.toggle.emit(state);
    }
  }

  public _state = false;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/slidedown/slidedown.component.ts